/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Group from 'material/group/group';
import Logo from 'material/graphic/logo/logo';
import Icon from 'material/graphic/icon/icon';
import Link from 'material/ctas/link/link_container';
import UnsavedMessage from 'material/message/popup/unsaved/unsaved_container';
// nav
import Nav from 'material/nav/nav';
import NavItem from 'material/nav/navitem/navitem';
// menu
import Menu from 'material/menu/menu_container';
import MenuTitle from 'material/menu/menutitle/menutitle';
import MenuGroup from 'material/menu/menugroup/menugroup';
import MenuItem from 'material/menu/menuitem/menuitem_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/structure/header/header_styles';



/* ========== ~~~~~~~~~~ STRUCTURE : HEADER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Header = (props) => {
	let signOutClicked = false;
	const handleSignOut = () => {
		if(signOutClicked) return null;
		if (props.editMode){
			return props.displayModal(true, <UnsavedMessage primaryAction={processSignOut} />);
		}
        return processSignOut();
	};
	const processSignOut = () => {signOutClicked = true; props.mocked ? props.unmockUser() : props.signOut()};
	return (
		<header id={`header`} className={`structure ${props.classes.header}`}>
			<Group name={`logo`}>
				<Link type={`internal`} name={`insticator`} action={`dashboard/home`} title={`Return to Home Page`}>
					<Logo name={`insticator-icon`} text={`Insticator`} />
				</Link>
			</Group>
			<Group name={`navs`}>
				<Group name={`sections`}>
					 <Nav name={`topnav`} variant={`bubble`}>
						<NavItem><Link type={`internal`} name={`home`} text={`Home`} action={`dashboard/home`} icon={<Icon name={`chart-line`} />} /></NavItem>
						<NavItem><Link type={`internal`} name={`embeds`} text={`Embeds`} action={`dashboard/embeds`} icon={<Icon name={`puzzle-piece`} />} /></NavItem>
						{ props.reportsPermitted ? <NavItem><Link type={`internal`} name={`reports`} text={`Reports`} action={`dashboard/reports`} icon={<Icon name={`chart-pie`} />} /></NavItem> : null }
						{/*<NavItem><Link type={`internal`} name={`audience`} text={`Audience`} action={`dashboard/audience`} icon={<Icon name={`users`} />} /></NavItem>*/}
						{/*<NavItem><Link type={`internal`} name={`content`} text={`Content`} action={`dashboard/content`} icon={<Icon name={`align-left`} />} /></NavItem>*/}
						{/*<NavItem><Link type={`internal`} name={`insights`} text={`Insights`} action={`dashboard/insights`} icon={<Icon name={`bolt`} />} /></NavItem>*/}
					</Nav>
				</Group>
				<Group name={`account`}>
					<div className={`greeting`}>Welcome</div>
	                <Menu name={`usermenu`} indicator={<span className={`username`}>{`${!!props.userFirstName ? props.userFirstName : ''}`} <Icon name={`sort-down`} /></span>}>
	                	<MenuGroup name={`accountitems`}>
	                		<MenuTitle text={`Account`} />
		                    <MenuItem><Link type={`internal`} name={`profile`} text={`Profile Information`} action={`dashboard/profile`} icon={<Icon name={`id-card`} />} /></MenuItem>
							<MenuItem disabled={!props.accountSettingsPermitted } ><Link type={`internal`} name={`general`} text={`Account Settings`} action={`dashboard/account`} icon={<Icon name={`cog`} />} /></MenuItem>
		                    {/*<MenuItem><Link type={`external`} name={`helpcenter`} text={`Help Center`} action={`https://support.insticator.com/`} icon={<Icon name={`question-circle`} />} /></MenuItem>*/}
		               	</MenuGroup>
						<MenuGroup name={`logoutitems`}>
		                	<MenuItem><Link type={'custom'} name={`menu-logout`} text={props.mocked ? `Unmock` : `Log out`} action={`logout`} handleClick={handleSignOut} icon={<Icon name={`sign-out-alt`} />} /></MenuItem>
		                </MenuGroup>
	                    <MenuGroup name={`pageitems`}>
	                    	<MenuTitle text={`Pages`} />
		                    <MenuItem><Link type={`internal`} name={`menu-home`} text={`Home`} action={`dashboard/home`} icon={<Icon name={`chart-line`} />} /></MenuItem>
		                    <MenuItem><Link type={`internal`} name={`menu-embeds`} text={`Embeds`} action={`dashboard/embeds`} icon={<Icon name={`puzzle-piece`} />} /></MenuItem>
                           { props.reportsPermitted ? <MenuItem><Link type={`internal`} name={`menu-reports`} text={`Reports`} action={`dashboard/reports`} icon={<Icon name={`chart-pie`} />} /></MenuItem> : null }
		                </MenuGroup>
	                </Menu>
					<Link type={'custom'} name={`logout`} text={props.mocked ? `Unmock` : `Log out`} action={`logout`} handleClick={handleSignOut} icon={<Icon name={`sign-out-alt`} />} iconRight />
				</Group>
			</Group>
		</header>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Header);
